import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import OwnerLayout from "../layout/OwnerLayout";
import { ActiveBarProvider } from "../ActiveBarContext";

import OwnerDashboard from "../owner/OwnerDashboard";
import LinkedCharities from "../owner/LinkedCharities";
import Gaming from "../owner/Gaming";
import Specials from "../owner/Specials";
import Jobs from "../owner/Jobs";
import BarProfile from "../owner/BarProfile";
import Subscription from "../owner/Subscription";
import Help from "../owner/Help";

import ClaimBar from "../shared/ClaimBar";
import EventsPage from "../shared/EventsPage";
import NotificationsPage from "../shared/NotificationsPage";
import AccountSettings from "../shared/AccountSettings";

import TodaysSpecial from "../owner/TodaysSpecial.jsx";
import Today from "../owner/Today.jsx";
import Offers from "../owner/Offers.jsx";

export default function OwnerDashboardRouter() {
  // Keep each account in its own dashboard: a charity account that lands
  // on a owner page (old tab, back button) gets sent to its own dashboard.
  const { user, role } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (role === "charity") return <Navigate to="/charity" replace />;

  return (
    <ActiveBarProvider roleField="ownerId">
      <OwnerLayout>
        <Routes>
          <Route path="" element={<Today />} />
          <Route path="overview" element={<OwnerDashboard />} />
          <Route path="linked-venues" element={<LinkedCharities />} />
          <Route path="claim-bar" element={<ClaimBar />} />
          <Route path="create-event" element={<EventsPage />} />
          <Route path="gaming-inventory" element={<Gaming />} />
          <Route path="post-update" element={<NotificationsPage />} />
          <Route path="specials" element={<Specials />} />
          <Route path="todays-special" element={<TodaysSpecial />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="bar-profile" element={<BarProfile />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="offers" element={<Offers />} />
          <Route path="help" element={<Help />} />
          <Route path="account" element={<AccountSettings />} />
        </Routes>
      </OwnerLayout>
    </ActiveBarProvider>
  );
}
